import languageService from '../../services/localization/languageService';
import {config} from '../config';
import {TConfigGetterReturn} from './types';

const CULTURE_CODE_MARKER = '{culture_code}';

const getCorrectLink = (linkPath: any): string | undefined => {
    if (linkPath) {
        const language = languageService.getCurrentLanguageCode();

        if (typeof linkPath === 'object') {
            const isSelectedLanguageLinkExists = !!linkPath[language];

            if (isSelectedLanguageLinkExists) {
                return linkPath[language];
            } else {
                const defaultLanguage = languageService.getDefaultLanguageCode();

                if (defaultLanguage) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return linkPath[defaultLanguage.toLowerCase()];
                }
            }
        } else if (typeof linkPath === 'string') {
            const isCultureCodeInsertNeeded = linkPath.indexOf(CULTURE_CODE_MARKER);

            if (isCultureCodeInsertNeeded) {
                return linkPath.replace(CULTURE_CODE_MARKER, language);
            } else {
                return linkPath;
            }
        }
    }
};

export default {
    getLinkAndroidStoreChrome: (): TConfigGetterReturn<string> =>
        getCorrectLink(config.data.appLinks.linkAndroidStoreChrome),
    getLinkDesktopChrome: (): TConfigGetterReturn<string> => getCorrectLink(config.data.appLinks.linkDesktopChrome),
    getLinkIosStoreBluenet: (): TConfigGetterReturn<string> => getCorrectLink(config.data.appLinks.linkIosStoreBluenet),
    getLinkAndroidStoreEdge: (): TConfigGetterReturn<string> =>
        getCorrectLink(config.data.appLinks.linkAndroidStoreEdge),
    getLinkDesktopEdge: (): TConfigGetterReturn<string> => getCorrectLink(config.data.appLinks.linkDesktopEdge),
};
